var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import * as React from 'react';
import { Container, Box } from '@mui/material';
import styled from 'styled-components';
import SessionLogo from './SessionLogo';
var Wrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  background-color: #333;\n  height: 100vh;\n  background-position: bottom 60% right 0;\n"], ["\n  display: flex;\n  align-items: center;\n  background-color: #333;\n  height: 100vh;\n  background-position: bottom 60% right 0;\n"])));
var SessionContainer = function (_a) {
    var role = _a.role, children = _a.children;
    return (React.createElement(Wrapper, null,
        React.createElement(Container, { maxWidth: "sm" },
            React.createElement(Box, { p: 4, borderRadius: "5px", bgcolor: "white", boxShadow: 2 },
                React.createElement(SessionLogo, { role: role }),
                children))));
};
export default SessionContainer;
var templateObject_1;
